import React from 'react';

const Publish = () => {
  return (
    <svg
      width='28'
      height='32'
      viewBox='0 0 28 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 0H28V4H0V0ZM0 20H8V32H20V20H28L14 6L0 20ZM16 16V28H12V16H9.66L14 11.66L18.34 16H16Z'
        fill='#4CAF92'
      />
    </svg>
  );
};

export default Publish;
